<!--
  ~ Copyright (C) 2026 DV Bern AG, Switzerland
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as
  ~ published by the Free Software Foundation, either version 3 of the
  ~ License, or (at your option) any later version.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program.  If not, see <https://www.gnu.org/licenses/>.
  -->

<lib-gesuch-page-layout>
    <lib-gesuch-page-heading>
        {{ 'Dagmar Wälti' | translate }}
        <dv-bisher-x
            [deklaration]="{}"
            [showBisher]="hasBisher()"
            [specificBisherText]="'DURCH_GEMEINDE_ERFASST' | translate"
            [showSpecificBisherTextIfBisherNone]="true"
            [showIfBisherNone]="true"
        ></dv-bisher-x>
    </lib-gesuch-page-heading>

    <fieldset class="tw:flex tw:flex-col">
        <h2>Testing Toggles</h2>
        <div class="tw:inline">
            <input type="checkbox" [(ngModel)]="hasBisher" id="has-bisher" />
            <label
                for="has-bisher"
                class="tw:inline tw:ml-2 ignore-danger-font-color tw:align-text-top"
                >Toggle dv-bisher fürs Testing
            </label>
        </div>
        <div class="tw:inline">
            <input
                type="checkbox"
                [(ngModel)]="isInvalid"
                (ngModelChange)="form.pensum().markAsTouched()"
                id="is-invalid"
            />
            <label
                for="is-invalid"
                class="tw:inline tw:ml-2 ignore-danger-font-color tw:align-text-top"
                >invalides Form
            </label>
        </div>
        <div class="tw:inline">
            <input type="checkbox" [(ngModel)]="isRequired" id="is-required" />
            <label
                for="is-required"
                class="tw:inline tw:ml-2 ignore-danger-font-color tw:align-text-top"
                >Pflichtfeld
            </label>
        </div>
        <div class="tw:inline">
            <input type="checkbox" [(ngModel)]="isDisabled" id="is-disabled" />
            <label
                for="is-disabled"
                class="tw:inline tw:ml-2 ignore-danger-font-color tw:align-text-top"
                >Read-only
            </label>
        </div>
    </fieldset>

    <fieldset class="tw:mt-4">
        <h2 class="tw:pb-4">Number Input (mit nativem label):</h2>
        <kib-gesuch-form-number-input
            class="tw:mt-12 tw:block"
            [formField]="form.pensum"
        >
            <span kibGesuchSharedFormLabelContent>
                Pensum
                <kib-tooltip>
                    <div [innerHTML]="'TEST_TOOLTIP' | translate"></div>
                </kib-tooltip>
            </span>
        </kib-gesuch-form-number-input>
    </fieldset>

    <fieldset>
        <h2>Number Input 2:</h2>
        <kib-gesuch-form-number-input [formField]="form.zweitesPensum">
            <span kibGesuchSharedFormLabelContent>Zweites Pensum</span>
        </kib-gesuch-form-number-input>
    </fieldset>
    <p>
        KibTooltip Text example erweitere Bedürfnisse:
        <kib-tooltip>
            <div [innerHTML]="'ERWEITERTE_BEDUERFNISSE_HINT' | translate"></div>
        </kib-tooltip>
    </p>
    <p>
        KibTooltip HTML example:
        <kib-tooltip>
            <h2>HTML Table</h2>

            <table>
                <tr>
                    <th>Company</th>
                    <th>Contact</th>
                    <th>Country</th>
                </tr>
                <tr>
                    <td>Alfreds Futterkiste</td>
                    <td>Maria Anders</td>
                    <td>Germany</td>
                </tr>
                <tr>
                    <td>Centro comercial Moctezuma</td>
                    <td>Francisco Chang</td>
                    <td>Mexico</td>
                </tr>
                <tr>
                    <td>Ernst Handel</td>
                    <td>Roland Mendel</td>
                    <td>Austria</td>
                </tr>
                <tr>
                    <td>Island Trading</td>
                    <td>Helen Bennett</td>
                    <td>UK</td>
                </tr>
                <tr>
                    <td>Laughing Bacchus Winecellars</td>
                    <td>Yoshi Tannamuri</td>
                    <td>Canada</td>
                </tr>
                <tr>
                    <td>Magazzini Alimentari Riuniti</td>
                    <td>Giovanni Rovelli</td>
                    <td>Italy</td>
                </tr>
            </table>
        </kib-tooltip>
    </p>
    <fieldset class="tw:mt-4">
        <h2>Bisher</h2>
        <section class="tw:pb-4">
            <span>Beispiel bisher (sonder Label) mit %: 100 %</span>

            @if (hasBisher()) {
                <kib-bisher id="erwerbspensum-bisher">
                    <span kibBisherLabel>
                        {{ 'LATS_BISHER_LABEL' | translate }}
                    </span>

                    <span kibBisherValue> {{ bisherValue }} % </span>
                </kib-bisher>
            }
        </section>
        <section>
            <span>Beispiel bisher (default label): 100</span>
            @if (hasBisher()) {
                <kib-bisher id="erwerbspensum-bisher">
                    <span kibBisherValue> {{ bisherValue }} </span>
                </kib-bisher>
            }
        </section>
    </fieldset>
</lib-gesuch-page-layout>
